import axios from 'axios';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
// import CustomClearIndicator from './MultiSelectBatches';
import Select from 'react-select';
import { BACKEND_SERVER_URL } from '../../../http/http-config';


import DateInput from '../Common-Components/DateInput';
import FileInput from '../Common-Components/FileInput';
import Input from '../Common-Components/Input';
import TinyEditor from '../Common-Components/TinyEditor';
import { setDropDownStyle } from '../CommonHelper';
import { checkExistingItem } from '../common-helpers/commonServices';
import BatchInput from './BatchInput';
import './Course.css';
import { fetchCourseData, formateCourseData, generateUniqueID, getExamTypes, getFaculties, getTypes, validateCourseData } from './CourseHelper';

let initialFormData = {
    examType: ' Select Exam Type',
    examTypeId: 0,
    sNo: '',
    title: '',
    urlTitle: '',
    price: 0,
    seatBookingPrice: 0,
    discount: 0,
    appDiscount: 0,
    type: 'Select Course Type',
    typeId: 0,
    topicCount: 0,
    duration: 0,
    faculty: 'Select Faculty',
    facultyId: 0,
    subscriptionCount: 0,
    currentBatchID: 0,
    description: '',
    imageURL: '',
    pdfURL: '',
    syllabusPDFURL: '',
    topics: '',
    tags: '',
    demoVideoLink: '',
    metaTitle: '',
    metaDescription: '',
    courseId: '',
    startDate: new Date(),
    admissionStartDate: new Date(),
    lessonUnlockTime: '00:00',
}


const CourseModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);    //new course
    const [courseData, setCourseData] = useState('');
    const [courseId, setCourseId] = useState('');
    const [modalName, setModal] = useState("")
    const [updatingCourseId, setUpdatingCourseId] = useState(null);
    const [examTypesArray, setExamTypesArray] = useState([]);
    const [typesArray, setTypesArray] = useState([]);
    const [TypesToDisplay, setTypesToDisplay] = useState([]);
    const [facultyArray, setFaculties] = useState([])
    const [formData, setFormData] = useState(initialFormData);
    const [updatingDataReady, setUpdatingDataReady] = useState(false);
    console.log(updatingCourseId, formData)
    const tempDescription = `<p style="text-align: justify;"><iframe style="width: 845px; height: 474px;" src="https://www.youtube.com/embed/5GoA5FowwWU?si=WwAibmou8tD-fRhd" width="845" height="474" allowfullscreen="allowfullscreen"></iframe><span style="font-family: Arial, sans-serif; font-size: 12pt;"><br>This is a&nbsp;Comprehensive Foundation Course&nbsp;of&nbsp;</span><strong style="font-family: Arial, sans-serif; font-size: 12pt;">&lsquo;History Optional&rsquo;&nbsp;</strong><span style="font-family: Arial, sans-serif; font-size: 12pt;">for UPSC Mains examination. This course has been specially designed by&nbsp;</span><strong style="font-family: Arial, sans-serif; font-size: 12pt;">incorporating the latest historical researches</strong><span style="font-family: Arial, sans-serif; font-size: 12pt;">&nbsp;and in accordance with the&nbsp;</span><strong style="font-family: Arial, sans-serif; font-size: 12pt;">new approaches emerging in field of Historical studies</strong><span style="font-family: Arial, sans-serif; font-size: 12pt;">&nbsp;so that students can score maximum marks in UPSC Mains exam.</span></p>
<div style="text-align: justify;">
<p class="MsoNormal" style="margin-top: 6pt; line-height: normal;"><span style="font-size: 12pt; font-family: Arial, sans-serif;">This course covers every dimension of UPSC History optional syllabus&nbsp;from &lsquo;<strong>Basic to Advance Level</strong>&rsquo;&nbsp;so that even the engineers and doctors having no academic background in history subject can also understand everything. Every topic will be taught from zero level as if students have no prior knowledge of History.</span></p>
<p class="MsoNormal" style="margin-top: 6pt; line-height: normal;"><span style="font-size: 12pt; font-family: Arial, sans-serif;">This course is for those students who are going to appear in Mains Examination this year or are preparing for the next year. The complete syllabus prescribed for the Mains Examination will be covered both intensively and extensively during the course.</span></p>
<p class="MsoNormal" style="margin-top: 6pt; line-height: normal;"><span style="font-size: 12pt; font-family: Arial, sans-serif;">The course will enable serious students to&nbsp;<strong>score 330 &ndash; 350 marks&nbsp;</strong>out of the total 500 in the IAS MAINS EXAMINATION easily. After the completion, of the course, every student will find it easy to write a very good answer to any question under examination conditions.</span></p>
<p class="MsoNormal" style="margin-top: 6.0pt; mso-margin-bottom-alt: auto; line-height: 115%; mso-outline-level: 3;"><span style="color: #e03e2d;"><strong><span style="font-size: 16pt; line-height: 115%; font-family: Arial, sans-serif;">Salient Features of History Optional Course</span></strong></span></p>
<ul>
<li><span style="font-size: 12pt; font-family: Arial, sans-serif;">INSIGHT History Optional Foundation Course&nbsp;covers even basics from&nbsp;<strong>NCERT Level (6 to 12 classes)</strong>&nbsp;along with the Advance Level of Learning.</span></li>
<li><span style="font-size: 12pt; font-family: Arial, sans-serif;">Every basic concept and terminology will be discussed in class to&nbsp;<strong>develop a&nbsp;comprehensive understanding</strong>&nbsp;of the entire History Optional syllabus.</span></li>
<li><span style="font-size: 12pt; font-family: Arial, sans-serif;">During the course, emphasis will be on the&nbsp;development of a thorough understanding&nbsp;of the subject matter rather than simply cramming the facts and figures. Special emphasis is given to concept building and multi-dimensional analysis.</span></li>
<li><span style="font-size: 12pt; font-family: Arial, sans-serif;">Computerized Study Material based on &lsquo;<strong>Latest Researches</strong>&rsquo; and &lsquo;New Approaches&rsquo;&nbsp;will be provided to all the students.</span></li>
<li><span style="font-size: 12pt; font-family: Arial, sans-serif;">Special session will be conducted for the &ldquo;<strong>Development of Writing Skills</strong>&rdquo;&nbsp;of students.</span></li>
<li><strong><span style="font-size: 12pt; font-family: Arial, sans-serif;">Regular Simulated Tests</span></strong><span style="font-size: 12pt; font-family: Arial, sans-serif;"> will be conducted on the pattern of UPSC Mains Examination&nbsp;to ensure the gradual improvement of the Writing Skills and to enrich the quality of answers.</span></li>
<li><span style="font-size: 12pt; font-family: Arial, sans-serif;">Kindly note that fee once paid for registration or admission to the course is non-refundable.</span></li>
</ul>
</div>"`

    console.log(examTypesArray)

    //check for existing items       
    const [itemAlreadyExist, setItemAlreadyExists] = useState(false);
    const [currentTitle, setCurrentTitle] = useState('');//for updating 
    useEffect(() => {
        if (formData.title && currentTitle.toLowerCase().trim() != formData.title.toLowerCase().trim()) { // current title is for updating case
            console.log('enter')
            let timer = setTimeout(() => {
                checkExistingItem('TblCourse', 'CourseTitle', formData.title).then(response => { //tablename and columnNane value
                    setItemAlreadyExists(response)
                })

            }, 500);
            return () => clearTimeout(timer);
        }

    }, [formData.title]);
    const [urlTitleAlreadyExist, setUrlTitleAlreadyExists] = useState(false);
    const [currentUrlTitle, setCurrentUrlTitle] = useState('');
    useEffect(() => {
        // Check if value exists and is different from the original (for update case)
        if (formData.urlTitle && currentUrlTitle.toLowerCase().trim() !== formData.urlTitle.toLowerCase().trim()) {
            let timer = setTimeout(() => {
                // 'TblCourse' is table, 'TitleHeading' is column, formData.urlTitle is value
                checkExistingItem('TblCourse', 'TitleHeading', formData.urlTitle).then(response => {
                    setUrlTitleAlreadyExists(response);
                });
            }, 500); // 500ms delay debounce
            return () => clearTimeout(timer);
        } else {
            // Reset if empty or matches original
            setUrlTitleAlreadyExists(false);
        }
    }, [formData.urlTitle]);

    useEffect(() => {
        console.log(formData.examTypeId)
        let filteredTypes = typesArray?.filter(obj => obj.examBodies?.includes(formData.examTypeId))
        console.log(filteredTypes)
        setTypesToDisplay(filteredTypes)
    }, [formData.examTypeId])

    useImperativeHandle(ref, () => ({
        openModal(CourseID) {
            getTypes().then((res) => {
                console.log(res)
                setTypesArray(res.filter(type => type.moduleType == 'course'));
            })
            getExamTypes().then((res) => {
                setExamTypesArray(res);
            })
            getFaculties().then((res) => {
                setFaculties(res);
            })
            if (CourseID) {
                setUpdatingCourseId(CourseID)
                setCourseId(CourseID)
                fetchCourseData(CourseID).then((course) => {
                    formateCourseData(course).then(formatedData => {
                        if (formatedData.title) {
                            formatedData.description = formatedData.description || tempDescription; // for changing the video link in description
                            setCurrentTitle(formatedData.title)
                            setCurrentUrlTitle(formatedData.urlTitle);
                            setFormData(formatedData)
                            setUpdatingDataReady(true)
                            // setModalBox(true);
                        }
                    })

                })
            } else {
                setFormData(initialFormData)
                let courseId = generateUniqueID();
                setCourseId(courseId);
                handleChange('courseId', courseId)//property name and value   
                // setModalBox(true);
            }
            setModalBox(true);


        }
    }));

    const handleChange = (name, value) => {
        console.log(name, value);
        setFormData((formData) => (
            { ...formData, [name]: value }
        ));
    };

    console.log(formData)
    const handleSubmitCourse = () => {
        let errorMessgae = validateCourseData(formData)

        if (errorMessgae) {
            toast.error(errorMessgae)
            return;
        } else if (itemAlreadyExist && currentTitle.toLowerCase().trim() != formData.title.toLowerCase().trim()) {
            toast.error("Course Already Exists")
            return;
        }
        else if (urlTitleAlreadyExist && currentUrlTitle.toLowerCase().trim() !== formData.urlTitle.toLowerCase().trim()) {
            toast.error("URL Title (Title Heading) Already Exists");
            return;
        }


        axios.post(BACKEND_SERVER_URL + (updatingCourseId ? `/updateCourse/${updatingCourseId}` : '/createCourse'), formData).then((response) => {
            if (response.data.statusCode == 201) {
                setFormData(initialFormData)
                toast.success(response.data.message)
                props.setCourseLoading(!props.loadCourses)
                setModalBox(false);
                setUpdatingCourseId(null)
            }
        }).catch((error) => {
            toast.error(error.response.data.message)
            console.log(error)
        })

    }
    useEffect(() => {
        if (!modalBox) {
            setFormData(initialFormData); // Reset form data when modal is closed
            setItemAlreadyExists(false)
            setCurrentTitle('')
            setUrlTitleAlreadyExists(false);
            setCurrentUrlTitle('');
            setUpdatingCourseId(null)
        }
    }, [modalBox]);

    return (
        <>
            <Modal className="" show={modalBox} onHide={setModalBox} dialogClassName="custom-modal-width" backdrop="static"
                keyboard={false} >
                <Modal.Header>
                    <Modal.Title>{updatingCourseId ? 'Update Course' : 'Create Course'}</Modal.Title>
                    <Button variant="" className="btn-close" onClick={() => setModalBox(false)}></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 d-flex justify-content-around ">
                                <div className="col-5 d-flex">
                                    <div className="col-sm-4 pt-2">
                                        <div className="mb-3" >
                                            <label htmlFor='news' className="form-label text-primary">Exam Type<span className="required">*</span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="mb-3">
                                            <Select
                                                value={{ value: formData.examType, label: formData.examType }}
                                                onChange={(selectedOption) => setFormData((formData) => ({ ...formData, examTypeId: selectedOption.value.Sn, examType: selectedOption.value.exambody }))}
                                                options={examTypesArray?.map((item) => ({ value: item, label: item.exambody }))}
                                                styles={setDropDownStyle()}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-5 d-flex">
                                    <div className="col-sm-4 pt-2">
                                        <div className="mb-3" >
                                            <label htmlFor='news' className="form-label text-primary">Type<span className="required">*</span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="mb-3">
                                            <Select
                                                value={{ value: formData.type, label: formData.type }}
                                                onChange={(selectedOption) => setFormData({ ...formData, typeId: selectedOption.value.sn, type: selectedOption.value.courseType })}
                                                options={TypesToDisplay?.map((item) => ({ value: item, label: item.courseType }))}
                                                styles={setDropDownStyle()}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="col-12 d-flex justify-content-around ">
                                <div className="col-5 d-flex">
                                    <Input inputType="text" isMandatory={true} handleChangeCallBack={handleChange} labelName="Title" inputValue={formData?.title} inputName='title' divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex flex-wrap">
                                    <Input isMandatory={true} inputType="text" handleChangeCallBack={handleChange} labelName="URL Title" inputValue={formData?.urlTitle} inputName='urlTitle' divSizes={[4, 8]} />
                                    {urlTitleAlreadyExist && currentUrlTitle.toLowerCase().trim() !== formData.urlTitle.toLowerCase().trim() && (
                                        <div className="w-100 d-flex" style={{ marginTop: "-10px" }}>
                                            {/* This empty div matches the space of the label (col-4) */}
                                            <div style={{ width: '33.3%' }}></div>

                                            {/* This span aligns with the input (col-8) */}
                                            <span className="text-danger small">
                                                * This URL Title already exists
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around">
                                <div className="col-5 d-flex">
                                    <Input isMandatory={true} handleChangeCallBack={handleChange} labelName="Price" inputType="number" inputValue={formData?.price} inputName='price' divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex">
                                    <Input isMandatory={false} handleChangeCallBack={handleChange} labelName="Seat Booking Price" inputType="number" inputValue={formData?.seatBookingPrice} inputName='seatBookingPrice' divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around  ">

                                <div className="col-5 d-flex">
                                    <Input isMandatory={false} handleChangeCallBack={handleChange} labelName="Discount %" inputType="number" inputValue={formData?.discount} inputName='discount' divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex">
                                    <Input isMandatory={false} handleChangeCallBack={handleChange} labelName="App Discount %" inputType="number" inputValue={formData?.appDiscount} inputName='appDiscount' divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex">
                                    <Input isMandatory={true} handleChangeCallBack={handleChange} labelName="Order No." inputType="number" inputValue={formData?.sNo} inputName='sNo' divSizes={[4, 8]} />
                                </div>

                                {/*  <div className="col-5 d-flex ">
                                    <DropdownInput handleChangeCallBack={handleChange} labelName="Type" selectedValue={formData?.type} inputName='type' dropdownValuesArray={typesArray} />
                                </div> */}
                                <div className="col-5 d-flex ">
                                    <Input isMandatory={true} handleChangeCallBack={handleChange} labelName="Course ID" inputType="text" inputValue={formData?.courseId || courseId} inputName='courseId' divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex">
                                    <Input isMandatory={false} handleChangeCallBack={handleChange} labelName="Lessons Count" inputValue={formData?.topicCount} inputName='topicCount' inputType="number" divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex">
                                    <Input isMandatory={false} handleChangeCallBack={handleChange} labelName="Duration (in Months)" inputValue={formData?.duration} inputName='duration' inputType="number" divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex">
                                    <div className="col-sm-4 pt-2">
                                        <div className="mb-3" >
                                            <label htmlFor='news' className="form-label text-primary">Faculty</label>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="mb-3">
                                            <Select
                                                value={{ value: formData.faculty, label: formData.faculty }}
                                                onChange={(selectedOption) => setFormData({ ...formData, facultyId: selectedOption.value.sn, faculty: selectedOption.value.facultyName })}
                                                options={facultyArray?.map((item) => ({ value: item, label: item.facultyName }))}
                                                styles={setDropDownStyle()}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/*   <div className="col-5 d-flex ">
                                    <DropdownInput handleChangeCallBack={handleChange} labelName="Faculty" selectedValue={formData?.faculty} inputName='faculty' dropdownValuesArray={facultyNamesArray} />
                                </div> */}

                                <div className="col-5 d-flex">
                                    <Input isMandatory={false} handleChangeCallBack={handleChange} labelName="Subscription Count" inputType="number" inputValue={formData?.subscriptionCount} inputName='subscriptionCount' divSizes={[4, 8]} />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around  ">
                                <div className="col-5 d-flex align-items-center">
                                    <DateInput labelName="Start Date" selected={formData?.startDate} handleChangeCallBack={handleChange} inputName='startDate' />
                                </div>
                                <div className="col-5 d-flex align-items-center">
                                    <DateInput labelName="Admission Start Date" selected={formData?.admissionStartDate} handleChangeCallBack={handleChange} inputName='admissionStartDate' />
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around mt-3">
                                <div className="col-5 d-flex align-items-center">
                                    <Input isMandatory={false} handleChangeCallBack={handleChange} labelName="Daily Lesson Unlock Time" inputType="time" inputValue={formData?.lessonUnlockTime} inputName='lessonUnlockTime' divSizes={[4, 8]} />
                                </div>
                                <div className="col-5 d-flex align-items-center">
                                </div>
                            </div>
                            <div className="col-12 d-flex  justify-content-between mt-3">
                                <BatchInput handleChangeCallBack={handleChange} labelName="Add Batch" courseId={courseId} inputValue={formData?.currentBatchID} inputName='currentBatchID' moduleName="coursePage" updating={updatingCourseId} />
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    {/*  <TinyEditor handleChangeCallBack={handleChange} labelName="Description" inputValue={formData?.description} inputName='description' /> */}
                                    <TinyEditor handleChangeCallBack={handleChange} labelName="Description/Features" inputValue={formData?.description} inputName='description' />

                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <FileInput isMandatory={false} handleChangeCallBack={handleChange} labelName="Image" inputType="text" uploadedFileURL={formData?.imageURL} inputName='imageURL' accept="image/jpeg, image/png, image/gif" />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <FileInput isMandatory={false} handleChangeCallBack={handleChange} labelName="PDF URL" inputType="text" uploadedFileURL={formData?.pdfURL} inputName='pdfURL' accept=".pdf" />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <FileInput isMandatory={false} handleChangeCallBack={handleChange} labelName="Syllabus PDF URL" inputType="text" uploadedFileURL={formData?.syllabusPDFURL} inputName='syllabusPDFURL' accept=".pdf" />
                                </div>
                            </div>

                            <div className="col-12 ">
                                <div className="d-flex">
                                    <Input isMandatory={false} handleChangeCallBack={handleChange} labelName="Brief Introduction" inputType="textarea" rowSize={5} inputValue={formData?.topics} inputName='topics' divSizes={[2, 10]} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <Input isMandatory={false} handleChangeCallBack={handleChange} labelName="Tags" inputType="text" inputValue={formData?.tags} inputName='tags' divSizes={[2, 10]} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <Input isMandatory={false} handleChangeCallBack={handleChange} labelName="Demo Video Link" inputType="text" inputValue={formData?.demoVideoLink} inputName='demoVideoLink' divSizes={[2, 10]} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <Input isMandatory={false} handleChangeCallBack={handleChange} labelName="Meta Title" inputType="text" inputValue={formData?.metaTitle} inputName='metaTitle' divSizes={[2, 10]} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <Input isMandatory={false} handleChangeCallBack={handleChange} labelName="Meta Description" inputType="textarea" rowSize={3} inputValue={formData?.metaDescription} inputName='metaDescription' divSizes={[2, 10]} />
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger light" className='btn-sm' onClick={() => setModalBox(false)}>Close</Button>
                    <Button variant="primary " className='btn-sm ' onClick={handleSubmitCourse}>{updatingCourseId ? 'Update Course' : 'Create Course'}</Button>
                </Modal.Footer>
            </Modal>


        </>
    )
})
export default CourseModal;